// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Form, Col, Row, Table } from "react-bootstrap";
// import { IoMdClose } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { BASE_URL } from "../../../services/Api";
// import { authHeader } from "../../../services/auth-header";

// const ViewAraiMfgQuotation = ({ enquiryData }) => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
//   const [productOptions, setProductOptions] = useState([]);
//   const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
//   const [customerDetailsOptions, setCustomerDetailsOptions] = useState();

//   const [enquiryDetails, setEnquiryDetails] = useState({
//     quotationtype: "Manufacturing",
//     quotationcategory: "International",
//     quotationdate: "",
//     enquiryrefno: "",
//     enquiryrefdate: "",
//     customer: "",
//     contactperson: "",
//     contactno: "",
//     email: "",
//     customeraddress: "",
//     deliveryterm: "",
//     incoterms: "",
//     paymentterm: "",
//     freight: "",
//     quotevalidity: "",
//     quotationItems: [],
//     grandtotalinr: "",
//     grandtotalcurrency: "",
//   });

//   const [customerNameValue, setCustomerNameValue] = useState({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
//   const [customerAddressValue, setCustomerAddressValue] = useState({ value: enquiryData?.customeraddress?.id, label: enquiryData?.customeraddress?.customeraddress });

//   console.log(enquiryData);

//   useEffect(() => {
//     const ans = enquiryData.quotationItems.map((item) => ({
//       product: {
//         id: item?.product?.id,
//       },
//       description: item?.product?.description,
//       productremarks: item?.productremarks,
//       itemcode: item?.product?.itemcode,
//       hsnsacno: item?.product?.hsnsacno,
//       tagnumber: item?.tagnumber,
//       modelnumber: item?.modelnumber,
//       serialnumber: item?.serialnumber,
//       moc: item?.moc,
//       partno: item?.partno,
//       uom: item.uom,
//       quantity: item.quantity,
//       unitrateinr: item.unitrateinr,
//       totalinr: item.totalinr,
//       currency: item.currency,
//       exchangerate: item.exchangerate,
//       unitratecurrency: item.unitratecurrency,
//       totalcurrency: item.totalcurrency,
//     }));

//     setEnquiryDetails({
//       ...enquiryDetails,
//       quotationno: enquiryData?.quotationno,
//       quotationdate: enquiryData?.quotationdate,
//       enquiryrefno: enquiryData?.enquiryrefno,
//       enquiryrefdate: enquiryData?.enquiryrefdate,
//       customer: enquiryData?.customer,
//       contactperson: enquiryData?.contactperson,
//       contactno: enquiryData?.contactno,
//       email: enquiryData?.email,
//       customeraddress: enquiryData?.customeraddress,
//       deliveryterm: enquiryData?.deliveryterm,
//       incoterms: enquiryData?.incoterms,
//       paymentterm: enquiryData?.paymentterm,
//       freight: enquiryData?.freight,
//       quotevalidity: enquiryData?.quotevalidity,
//       quotationItems: ans,
//       grandtotalinr: enquiryData?.grandtotalinr,
//       grandtotalcurrency: enquiryData?.grandtotalcurrency,
//       status: enquiryData?.status,
//       quotationcurrency: enquiryData?.quotationcurrency,
//       quotationexchangerate: enquiryData?.quotationexchangerate,
//       enquiryid: enquiryData?.enquiryid,
//     });

//     getCustomerAddress(enquiryData.customer.id);
//   }, []);

//   async function getCustomerData() {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });
//       setCustomerOptions(
//         response.data.Index
//           ? response.data.Index.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//           : response.data.data.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getProductData() {
//     try {
//       const response = await axios.get(`${BASE_URL}product/page/tube/0/5/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });

//       setProductOptions(
//         response.data.Index
//           ? response.data.Index.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//           : response.data.data.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerDetails(id) {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
//         headers: authHeader(),
//       });
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customer: {
//           id: id,
//         },
//         contactperson: response.data.contactperson,
//         contactno: response.data.contactno,
//         email: response.data.email,
//         customeraddress: response.data.address,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerAddress(id) {
//     try {
//       const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
//         headers: authHeader(),
//       });

//       console.log(response);
//       setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
//     } catch (error) { }
//   }

//   async function handleProductChange(event) {
//     try {
//       const response = await axios.get(`${BASE_URL}product/findById/${event.value}`, {
//         headers: authHeader(),
//       });

//       console.log(response);

//       let row = {
//         product: {
//           id: response.data.id,
//         },
//         description: response.data.description,
//         itemcode: response.data.itemcode,
//         hsncode: response.data.hsnsacno,
//         tagnumber: response.data.tagnumber,
//         modelnumber: response.data.modelnumber,
//         uom: response.data.unitofmeasurement,
//         quantity: "",
//         unitrateinr: "",
//         totalinr: "",
//         currency: "",
//         exchangerate: "",
//         unitratecurrency: "",
//         totalcurrency: "",
//       };

//       setEnquiryDetails({
//         ...enquiryDetails,
//         quotationItems: [...enquiryDetails.quotationItems, row],
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function handleSubmit(event) {
//     event.preventDefault();

//     try {
//       const response = await axios.put(`${BASE_URL}quotation/update/${id}`, enquiryDetails, {
//         headers: authHeader(),
//       });

//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: "Enquiry added successfully!",
//       });

//       navigate("/quotationIndexTable/1");
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   const handleFormChange = (event, element) => {
//     if (element === "manufacturedby") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         manufacturedby: event.value,
//       });

//       return;
//     }

//     if (element === "customer") {
//       getCustomerDetails(event.value);
//       getCustomerAddress(event.value);
//       setCustomerNameValue(event);
//       setCustomerAddressValue("");
//       return;
//     }

//     if (element === "customeraddress") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customeraddress: {
//           id: event.value,
//         },
//       });

//       setCustomerAddressValue(event);
//       return;
//     }

//     const { name, value } = event.target;
//     setEnquiryDetails({
//       ...enquiryDetails,
//       [name]: value,
//     });
//   };

//   const handleQuantityChange = (event, index) => {
//     let rows = enquiryDetails.quotationItems;

//     rows[index].quantity = event.target.value;
//     rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
//     rows[index].totalinr = Number(rows[index].quantity) * Number(rows[index].unitrateinr);

//     setEnquiryDetails({
//       ...enquiryDetails,
//       quotationItems: rows,
//     });
//     handleGrandTotal();
//   };

//   const handleUnitRateChange = (event, index) => {
//     let rows = enquiryDetails.quotationItems;

//     rows[index].unitrateinr = event.target.value;
//     rows[index].amount = Number(rows[index].quantity) * Number(rows[index].unitrateinr);
//     const gstAmount = (rows[index].amount * Number(rows[index].gst)) / 100; // Calculate GST as a percentage of the amount
//     rows[index].totalinr = rows[index].amount + gstAmount;
//     rows[index].totalinr = roundToDecimalPlaces(rows[index].totalinr, 2);

//     setEnquiryDetails({
//       ...enquiryDetails,
//       quotationItems: rows,
//     });

//     handleGrandTotal();
//   };

//   const handleGrandTotal = (items = enquiryDetails.quotationItems) => {
//     let grandTotal = 0;

//     for (let i = 0; i < items.length; i++) {
//       grandTotal += Number(items[i].totalinr);
//     }

//     let finalTotal = roundToDecimalPlaces(grandTotal, 2);

//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       grandtotalinr: finalTotal,
//     }));

//     handleGrandTotalCurrency();
//   };

//   const handleGrandTotalCurrency = (items = enquiryDetails.quotationItems) => {
//     let grandTotal = 0;

//     for (let i = 0; i < items.length; i++) {
//       grandTotal += Number(items[i].totalcurrency);
//     }

//     let finalTotal = roundToDecimalPlaces(grandTotal, 2);

//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       grandtotalcurrency: finalTotal,
//     }));
//   };

//   function handleUnitRateCurrencyChange(event, index) {
//     let rows = enquiryDetails.quotationItems;

//     rows[index].unitratecurrency = event.target.value;
//     rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
//     rows[index].unitrateinr = Number(rows[index].unitratecurrency) * Number(rows[index].exchangerate);

//     setEnquiryDetails({
//       ...enquiryDetails,
//       quotationItems: rows,
//     });

//     handleGrandTotalCurrency();
//   }

//   function handleExchangeRate(event, index) {
//     let rows = enquiryDetails.quotationItems;

//     rows[index].exchangerate = event.target.value;
//     rows[index].unitrateinr = Number(rows[index].exchangerate) * Number(rows[index].unitratecurrency);
//     rows[index].totalinr = Number(rows[index].unitrateinr) * Number(rows[index].quantity);

//     setEnquiryDetails({
//       ...enquiryDetails,
//       quotationItems: rows,
//     });

//     handleGrandTotal();
//   }

//   function roundToDecimalPlaces(value, decimalPlaces) {
//     const factor = Math.pow(10, decimalPlaces);
//     return Math.round(value * factor) / factor;
//   }

//   const removeRow = (idx) => {
//     // Filter out the item at the specified index
//     const newItems = enquiryDetails.quotationItems.filter((_, index) => index !== idx);

//     // Update state with the new items
//     setEnquiryDetails((prevDetails) => ({
//       ...prevDetails,
//       quotationItems: newItems,
//     }));

//     // Call handleGrandTotal to recalculate the grand total
//     handleGrandTotal(newItems);
//     handleGrandTotalCurrency(newItems); // Pass the updated items
//   };

//   useEffect(() => {
//     getCustomerData();
//     getProductData();
//   }, []);

//   useEffect(() => {
//     getCustomerData();
//   }, [customerSearch]);

//   useEffect(() => {
//     getProductData();
//   }, [productSearch]);

//   console.log(enquiryDetails);

//   return (
//     <div className="container">
//       <br></br>

//       <Form>
//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Quotation No.</Form.Label>
//               <Form.Control disabled type="text" name="quotationno" value={enquiryDetails.quotationno} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Quotation Date</Form.Label>
//               <Form.Control disabled type="date" name="quotationdate" value={enquiryDetails.quotationdate} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//         </Row>
//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Enquiry Ref No.</Form.Label>
//               <Form.Control disabled type="text" name="enquiryrefno" value={enquiryDetails.enquiryrefno} onChange={handleFormChange} placeholder="Enquiry Ref No." />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Enquiry Ref Date</Form.Label>
//               <Form.Control disabled type="date" name="enquiryrefdate" value={enquiryDetails.enquiryrefdate} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Customer Name</Form.Label>
//               <Select
//                 isDisabled
//                 value={customerNameValue}
//                 options={customerOptions}
//                 onChange={(event) => handleFormChange(event, "customer")}
//                 onInputChange={(event) => {
//                   setCustomerSearch(event);
//                 }}
//               />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Contact Person</Form.Label>
//               <Form.Control value={enquiryDetails.contactperson} disabled />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Contact Number</Form.Label>
//               <Form.Control value={enquiryDetails.contactno} disabled />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Email</Form.Label>
//               <Form.Control value={enquiryDetails.email} disabled />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Payment Terms</Form.Label>
//               <Form.Control disabled type="text" name="paymentterm" value={enquiryDetails.paymentterm} onChange={handleFormChange} placeholder="Payment Terms" />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Customer Address</Form.Label>
//               <Select isDisabled value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Delivery Terms</Form.Label>
//               <Form.Control disabled type="text" name="deliveryterm" value={enquiryDetails.deliveryterm} onChange={handleFormChange} placeholder="Delivery Terms" />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Inco Terms</Form.Label>
//               <Form.Control disabled type="text" name="incoterms" value={enquiryDetails.incoterms} onChange={handleFormChange} placeholder="Inco Terms" />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Quote Validity</Form.Label>
//               <Form.Control disabled type="text" name="quotevalidity" value={enquiryDetails.quotevalidity} onChange={handleFormChange} placeholder="Quote Validity" />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Status</Form.Label>
//               <Form.Control disabled type="text" name="status" value={enquiryDetails.status} onChange={handleFormChange} placeholder="P and F" />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Currency</Form.Label>
//               <Form.Select disabled onChange={(e) => handleFormChange(e, "quotationcurrency")} name="quotationcurrency" value={enquiryDetails.quotationcurrency}>
//                 <option>Select Currency</option>
//                 <option value="$ (USD)">$ (USD)</option>
//                 <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
//                 <option value="GBP (Pounds)">GBP (Pounds)</option>
//                 <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
//                 <option value="₹ (INR)">₹ (INR)</option>
//               </Form.Select>
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Exchange Rate (Rs)/Currency</Form.Label>
//               <Form.Control disabled type="number" onChange={(e) => handleFormChange(e, "quotationexchangerate")} value={enquiryDetails.quotationexchangerate} name="quotationexchangerate" />
//             </Form.Group>
//           </Col>
//         </Row>

//         <br></br>
//         <div className="table-responsive">
//           <Table>
//             <thead>
//               <tr>
//                 <th>Product Description</th>
//                 <th>Product Code</th>
//                 <th>HSN Code</th>
//                 <th>Tag No.</th>
//                 <th>Model No.</th>
//                 <th>Serial No.</th>
//                 <th>Part No.</th>
//                 <th>MOC</th>
//                 <th>unit of measurement</th>
//                 <th>Currency</th>
//                 <th>Quantity</th>
//                 <th>Unit Rate (Currency)</th>
//                 <th>Total (Currency)</th>
//                 <th>Exchange Rate (Rs)/ Currency</th>
//                 <th>Unit Rate (Rs)</th>
//                 <th>Total (Rs)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {enquiryDetails.quotationItems.map((item, index) => (
//                 <tr key={index}>
//                   <td>
//                     {item.description}
//                     <Form.Control
//                       disabled
//                       as="textarea"
//                       rows={2}
//                       className="remarks"
//                       type="text"
//                       value={item.productremarks}
//                       onChange={(e) => {
//                         const newRows = [...enquiryDetails.quotationItems];
//                         newRows[index].productremarks = e.target.value;
//                         setEnquiryDetails({ ...enquiryDetails, quotationItems: newRows });
//                       }}
//                       placeholder="Enter item remarks"
//                       contentEditable="true"
//                     />
//                   </td>
//                   <td>{item.itemcode}</td>
//                   <td>{item.hsnsacno}</td>
//                   <td>{item.tagnumber}</td>
//                   <td>{item.modelnumber}</td>
//                   <td>{item.serialnumber}</td>
//                   <td>{item.partno}</td>
//                   <td>{item.moc}</td>
//                   <td>
//                     <Form.Select
//                       className="uom"
//                       disabled
//                       value={item.uom ? item.uom.toLowerCase() : ""}
//                       onChange={(event) => {
//                         // Update the unit of measurement in the respective item
//                         const newItems = [...enquiryDetails.enquiryItems];
//                         newItems[index].uom = event.target.value; // Store the selected value as is
//                         setEnquiryDetails({ ...enquiryDetails, enquiryItems: newItems });
//                       }}
//                     >
//                       <option value="">Select UOM</option>
//                       <option value="bot (bottle)">Bot (Bottle)</option>
//                       <option value="ctn (carton)">Ctn (Carton)</option>
//                       <option value="days">Days</option>
//                       <option value="ft (feet)">Ft (FEET)</option>
//                       <option value="hrs (hour)">Hrs (Hour)</option>
//                       <option value="kg (kilogram)">Kg (Kilogram)</option>
//                       <option value="kgs.">Kgs.</option>
//                       <option value="ltr (littre)">Ltr (Littre)</option>
//                       <option value="mtr">Mtr</option>
//                       <option value="nos (number)">Nos (Number)</option>
//                       <option value="pil (pail)">Pil (Pail)</option>
//                       <option value="pkt (packet)">Pkt (Packet)</option>
//                       <option value="set (sets)">Set (Sets)</option>
//                       <option value="pcs (pcs)">Pcs (Pcs)</option>
//                     </Form.Select>
//                   </td>

//                   <td>
//                     <Form.Select
//                       className="uom"
//                       disabled
//                       style={{ width: "100px" }}
//                       value={item.currency}
//                       onChange={(event) => {
//                         // Update the unitofmeasurement in the respective item
//                         const newItems = [...enquiryDetails.quotationItems];
//                         newItems[index].currency = event.target.value;
//                         setEnquiryDetails({ ...enquiryDetails, quotationItems: newItems });
//                       }}
//                     >
//                       <option>Select Currency</option>
//                       <option value="$ (USD)">$ (USD)</option>
//                       <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
//                       <option value="GBP (Pounds)">GBP (Pounds)</option>
//                       <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
//                       <option value="₹ (INR)">₹ (INR)</option>
//                     </Form.Select>
//                   </td>
//                   <td>
//                     <Form.Control className="uom" disabled value={item.quantity} min="0" type="number" onChange={(event) => handleQuantityChange(event, index)} />
//                   </td>

//                   <td>
//                     <Form.Control disabled min="0" type="number" onChange={(event) => handleUnitRateCurrencyChange(event, index)} value={item.unitratecurrency} />
//                   </td>

//                   <td>
//                     <Form.Control className="uom" min="0" type="text" disabled value={item.totalcurrency} />
//                   </td>

//                   <td>
//                     <Form.Control className="uom" disabled style={{ width: "90px" }} min="0" type="number" value={item.exchangerate} onChange={(event) => handleExchangeRate(event, index)} />
//                   </td>

//                   <td>
//                     <Form.Control className="uom" style={{ width: "100px" }} min="0" type="text" value={item.unitrateinr} disabled onChange={(event) => handleUnitRateChange(event, index)} />
//                   </td>

//                   <td>
//                     <Form.Control className="uom" disabled style={{ width: "100px" }} min="0" type="text" disabled value={item.totalinr} />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//             <tfoot>
//               <tr>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td style={{ fontWeight: "700" }}>Grand Total (Currency)</td>
//                 <td>
//                   <Form.Control min="0" type="number" disabled value={enquiryDetails.grandtotalcurrency} />
//                 </td>
//               </tr>
//               <tr>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//                 <td style={{ fontWeight: "700" }}>Grand Total (Rs)</td>
//                 <td>
//                   <Form.Control min="0" type="number" disabled value={enquiryDetails.grandtotalinr} />
//                 </td>
//               </tr>
//             </tfoot>
//           </Table>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default ViewAraiMfgQuotation;





import axios from "axios";
import React, { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Badge, Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";
import { FaArrowLeft } from "react-icons/fa";

const ViewAraiMfgQuotation = ({ enquiryData }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [quotationDetails, setQuotationDetails] = useState(null);
  const [customerAddress, setCustomerAddress] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (enquiryData) {
      setQuotationDetails({
        quotationno: enquiryData?.quotationno,
        quotationdate: enquiryData?.quotationdate,
        quotationtype: enquiryData?.quotationtype,
        quotationcategory: enquiryData?.quotationcategory,
        enquiryrefno: enquiryData?.enquiryrefno,
        enquiryrefdate: enquiryData?.enquiryrefdate,
        customer: enquiryData?.customer,
        contactperson: enquiryData?.contactperson,
        contactno: enquiryData?.contactno,
        email: enquiryData?.email,
        deliveryterm: enquiryData?.deliveryterm,
        incoterms: enquiryData?.incoterms,
        paymentterm: enquiryData?.paymentterm,
        quotevalidity: enquiryData?.quotevalidity,
        status: enquiryData?.status,
        quotationcurrency: enquiryData?.quotationcurrency,
        quotationexchangerate: enquiryData?.quotationexchangerate,
        grandtotalinr: enquiryData?.grandtotalinr,
        grandtotalcurrency: enquiryData?.grandtotalcurrency,
      });

      setCustomerAddress(enquiryData?.customeraddress);

      if (enquiryData?.quotationItems && enquiryData.quotationItems.length > 0) {
        setRows(enquiryData.quotationItems.map(item => ({
          description: item.product?.description || '-',
          productremarks: item.productremarks || "-",
          itemcode: item.product?.itemcode || item.itemcode || "-",
          hsnsacno: item.product?.hsnsacno || item.hsnsacno || "-",
          tagnumber: item.tagnumber || "-",
          modelnumber: item.modelnumber || "-",
          serialnumber: item.serialnumber || "-",
          partno: item.partno || "-",
          moc: item.moc || "-",
          uom: item.uom || "-",
          currency: item.currency || "-",
          quantity: item.quantity || 0,
          unitratecurrency: item.unitratecurrency || 0,
          totalcurrency: item.totalcurrency || 0,
          exchangerate: item.exchangerate || 0,
          unitrateinr: item.unitrateinr || 0,
          totalinr: item.totalinr || 0,
        })));
      }
      setIsLoading(false);
    }
  }, [enquiryData]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(value || 0);

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0.00';
    return parseFloat(value).toFixed(2);
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Active': return 'success';
      case 'Draft': return 'secondary';
      case 'Pending': return 'warning';
      case 'Completed': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'info';
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!quotationDetails) {
    return <div className="alert alert-danger text-center mt-4">Quotation not found</div>;
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">MANUFACTURING QUOTATION - VIEW</h5>
            <div>
              <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-1" />
                Back
              </Button>
            </div>
          </div>

          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">Quotation No</small>
                <div className="fw-bold">{quotationDetails.quotationno || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">Quotation Date</small>
                <div className="fw-bold">{formatDate(quotationDetails.quotationdate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Currency</small>
                <div className="fw-bold">{quotationDetails.quotationcurrency || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge bg={getStatusBadge(quotationDetails.status)} className="px-2 py-1">
                    {quotationDetails.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Quotation Details */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Quotation Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Enquiry Ref No</small>
              <div className="fw-bold">{quotationDetails.enquiryrefno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Enquiry Ref Date</small>
              <div className="fw-bold">{formatDate(quotationDetails.enquiryrefdate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Exchange Rate (₹/Currency)</small>
              <div className="fw-bold">{quotationDetails.quotationexchangerate || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Delivery Term</small>
              <div className="fw-bold">{quotationDetails.deliveryterm || '-'}</div>
            </Col>
            <Col md={4}>  
              <small className="text-muted">Inco Terms</small>
              <div className="fw-bold">{quotationDetails.incoterms || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Payment Term</small>
              <div className="fw-bold">{quotationDetails.paymentterm || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Quote Validity</small>
              <div className="fw-bold">{quotationDetails.quotevalidity || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Customer Information */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Company Name</small>
              <div className="fw-bold">{quotationDetails.customer?.companyname || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Contact Person</small>
              <div className="fw-bold">{quotationDetails.contactperson || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">GST No</small>
              <div className="fw-bold">{quotationDetails.customer?.gstno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Phone</small>
              <div className="fw-bold">{quotationDetails.contactno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Email</small>
              <div className="fw-bold">{quotationDetails.email || '-'}</div>
            </Col>
            <Col md={12}>
              <small className="text-muted">Address</small>
              <div className="fw-bold">{getAddressString(customerAddress)}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Quotation Items */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Quotation Items</h6>
        </div>
        <div className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Item Code</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2">Tag No</th>
                  <th className="fw-bold py-2">Model No</th>
                  <th className="fw-bold py-2">Serial No</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">MOC</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2">Currency</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (Curr)</th>
                  <th className="fw-bold py-2 text-end">Total (Curr)</th>
                  <th className="fw-bold py-2 text-end">Exch Rate</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (₹)</th>
                  <th className="fw-bold py-2 text-end">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{row.description || '-'}</div>
                      {row.productremarks && row.productremarks !== '-' && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {row.productremarks}</small>
                        </div>
                      )}
                    </td>
                    <td>{row.itemcode || '-'}</td>
                    <td>{row.hsnsacno || '-'}</td>
                    <td>{row.tagnumber || '-'}</td>
                    <td>{row.modelnumber || '-'}</td>
                    <td>{row.serialnumber || '-'}</td>
                    <td>{row.partno || '-'}</td>
                    <td>{row.moc || '-'}</td>
                    <td className="text-center">{row.uom || '-'}</td>
                    <td>{row.currency || '-'}</td>
                    <td className="text-center">{row.quantity || '0'}</td>
                    <td className="text-end">{formatNumber(row.unitratecurrency)}</td>
                    <td className="text-end">{formatNumber(row.totalcurrency)}</td>
                    <td className="text-end">{formatNumber(row.exchangerate)}</td>
                    <td className="text-end">{formatCurrency(row.unitrateinr)}</td>
                    <td className="text-end fw-semibold">{formatCurrency(row.totalinr)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light">
                <tr>
                  <td colSpan="13" className="text-end fw-bold py-2">Grand Total (Currency):</td>
                  <td colSpan="2" className="text-end fw-bold py-2">{formatNumber(quotationDetails.grandtotalcurrency)}</td>
                  <td colSpan="2" className="text-end fw-bold py-2"></td>
                </tr>
                <tr>
                  <td colSpan="13" className="text-end fw-bold py-2">Grand Total (₹):</td>
                  <td colSpan="2" className="text-end fw-bold py-2"></td>
                  <td colSpan="2" className="text-end fw-bold py-2 text-primary">{formatCurrency(quotationDetails.grandtotalinr)}</td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
          <FaArrowLeft className="me-1" />
          Back to List
        </Button>
      </div>
    </Container>
  );
};

export default ViewAraiMfgQuotation;